import React, { useState } from 'react';
import ModuleHeader from '../common/ModuleHeader';
import { Landmark, BarChart3, ListChecks } from 'lucide-react';
import PositionTresorerie from './PositionTresorerie';
import ComptesBancaires from './ComptesBancaires';
import OperationsRapprochement from './OperationsRapprochement';

type TabType = 'position' | 'comptes' | 'rapprochement';

const TresorerieModule: React.FC = () => {
  const [activeTab, setActiveTab] = useState<TabType>('position');

  const tabs = [
    { id: 'position' as TabType, name: 'Position', icon: BarChart3 },
    { id: 'comptes' as TabType, name: 'Comptes bancaires', icon: Landmark },
    { id: 'rapprochement' as TabType, name: 'Opérations & rapprochement', icon: ListChecks },
  ];

  return (
    <div className="w-full space-y-5">
      <ModuleHeader
        title="Trésorerie"
        subtitle="Position consolidée, comptes bancaires et rapprochements"
        icon={Landmark}
        tabs={tabs}
        active={activeTab}
        onChange={setActiveTab}
      />

      <div className="w-full">
        {activeTab === 'position' && <PositionTresorerie />}
        {activeTab === 'comptes' && <ComptesBancaires />}
        {activeTab === 'rapprochement' && <OperationsRapprochement />}
      </div>
    </div>
  );
};

export default TresorerieModule;
